import BankingOperation from '../../Operation'
import WithdrawForm from '../../Forms/WithdrawForm'

export default function BankingWithdraw ({ requestConfig, onTabNavigate, onCompleted, ...props }) {
  return (
    <BankingOperation title='Sacar' onTabNavigate={onTabNavigate} {...props}>
      {({ availableBalance }) => (
        <WithdrawForm
          availableBalance={availableBalance}
          requestConfig={requestConfig}
          onCompleted={onCompleted}
        />
      )}
    </BankingOperation>
  )
}
